import { render } from "./HealthWealth.vue?vue&type=template&id=b5334b20&scoped=true"
import script from "./HealthWealth.vue?vue&type=script&lang=js"
export * from "./HealthWealth.vue?vue&type=script&lang=js"

import "./HealthWealth.vue?vue&type=style&index=0&id=b5334b20&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5334b20"]])

export default __exports__